import apiSales from '../apiSales';

import { ParamsBodyPostCreateOrder, ParamsDataPostCreateOrder } from 'utils/typeServices';

type response = {
    errorCode: null;
    message: string;
    IsSuccess: boolean;
    Data: ParamsDataPostCreateOrder;
}

export const PostCreateOrder = async ({ body }: { body: ParamsBodyPostCreateOrder }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiSales.post<response>('/order/v3', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
